import { render } from "./Bets.vue?vue&type=template&id=1e4e8065&scoped=true"
import script from "./Bets.vue?vue&type=script&lang=js"
export * from "./Bets.vue?vue&type=script&lang=js"

import "./Bets.vue?vue&type=style&index=0&id=1e4e8065&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4e8065"]])

export default __exports__